import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  ElementRef,
  OnChanges
} from '@angular/core';

import { Grid } from '../../../lib/grid';
import { DataSource } from '../../../lib/data-source/data-source';

@Component({
    selector: '[ng2-st-add-button]',
    template: `
    <button
      tooltip="{{ addNewButtontoolTip | translate }}"
      *ngIf="isActionAdd"
      id="add"
      class="btn {{ addNewButtonClass }}"
      type="button"
      (click)="onAdd($event)"
    >
      {{ addNewButtonContent }}
    </button>
  `,
    standalone: false
})
export class AddButtonComponent implements AfterViewInit, OnChanges {
  @Input() public grid: Grid;
  @Input() public source: DataSource;
  @Output() public add = new EventEmitter<any>();

  public isActionAdd: boolean;
  public addNewButtonContent: string;
  public addNewButtonClass: string;
  public addNewButtontoolTip: string;

  constructor(private ref: ElementRef) {}

  public ngAfterViewInit() {
    this.ref.nativeElement.classList.add(
      'ng2-smart-actions-title',
      'ng2-smart-actions-title-add'
    );
  }

  public ngOnChanges() {
    this.isActionAdd = this.grid.getSetting('actions.add');
    this.addNewButtonContent = this.grid.getSetting('add.addButtonContent');
    this.addNewButtonClass = this.grid.getSetting('add.class');
    this.addNewButtontoolTip = this.grid.getSetting('add.tooltip');
  }

  public onAdd(event: any) {
    let isEditMode = false;
    let isAddAllowed = false;
    event.preventDefault();
    event.stopPropagation();
    this.add.emit({
      source: this.source
    });

    const lastRow = this.grid.getLastRow();
    let perPage = this.grid.source.getPaging().perPage;
    if (
      lastRow &&
      (lastRow.isNewRow ||
        lastRow.isDeleted ||
        lastRow.isInEditing ||
        lastRow.isReissued ||
        lastRow.isRevoked ||
        lastRow.isUndo)
    ) {
      isEditMode = true;
    }
    // if last row is in edit mode then dont allow further add.
    if (lastRow && lastRow.index === perPage - 1 && isEditMode) {
      // do nothing
    } else {
      let pagingConf;
      let position;
      let rows = this.grid.getRows();
      pagingConf = this.source.getPaging();
      let isFilterPresent = false;
      this.source.getAll().then((data) => {
        for (const row of rows) {
          if (row.isNewRow) {
            let dataSetRow = this.grid
              .getDataSet()
              .findRowByData(row.getData());
            let index = data.findIndex((record) => {
              if (record.uid === dataSetRow.data.uid) {
                return true;
              }
            });
            let validatorData = dataSetRow.getValidator().value;
            validatorData['uid'] = dataSetRow.data.uid;
            validatorData['isNewRow'] = true;
            dataSetRow.setData(validatorData);
            if (index !== -1) {
              data[index] = dataSetRow.data;
            }
          }
        }
        position = perPage * (pagingConf.page - 1);
        this.grid.create(this.grid.getNewRow(), this.add, position);
      });
    }
  }
}
